import * as React from 'react'
import { Text } from '@amzn/dvui/dist/Text'
import { RecordRefTag } from '@utils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TrailerButton } from '../playButton/PlayButton'
import { TRAILER_REFTAG } from '../../selectors/player'
import { PlayerContext } from '../../../../shared/player/integration/playbackArea'
import { ButtonProps, Translucent } from '@amzn/dvui/dist/Button'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as st from './playback.module.scss'
import * as cn from 'classnames'
import { TextLocalizer } from '../localizer/localizer'
import * as utilityClasses from '../utilityClasses.module.scss'

export interface ITrailerProps extends AtfTreatmentProps {
  playbackData?: WpsRuntime.atv.wps.TrailerFragmentModelProps
}

export const Trailer = ({
  playbackData,
  atfTreatment
}: ITrailerProps) => {
  if (!playbackData) {
    return null
  }

  const playbackConfig = {
    contentConfig: {
      asin: playbackData.playbackID,
      trailer: true,
      position: 0,
      ref: TRAILER_REFTAG,
      videoType: playbackData.videoMaterialType,
      useFullView: true,
    },
    playbackUrl: playbackData.playbackURL,
    fallbackUrl: playbackData.fallbackURL,
  }

  const atfTreatmentProps: ButtonProps = {
    ...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && {
      forceDoubleHeight: false,
      className: st.trailerButton
    }),
    ...(isTreatment(atfTreatment,'T1', 'T3') && {
      shape: 'pill',
    }),
    ...(isTreatment(atfTreatment,'T3') && {
      use: Translucent
    }),

  }

  return (
    <PlayerContext.Consumer>
      {({ onPlay }) => {
        const onClick = (e: React.MouseEvent) => {
          onPlay(playbackConfig)
          e.preventDefault()
        }

        return (
          <RecordRefTag
            refTag={TRAILER_REFTAG}
            className={cn(isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.trailerWrapper : utilityClasses.fullWidthPhablet, 'dv-dp-node-trailer')}>
            <TrailerButton
              onClick={onClick}
              forceDoubleHeight={true}
              href={playbackData.playbackURL}
              {...atfTreatmentProps}>
              {isTreatment(atfTreatment, 'T1', 'T2', 'T3') ?
                <TextLocalizer stringID='DV_DP_trailer__AV' />
                :
                <Text tag='span' string={playbackData.text} />
              }
            </TrailerButton>
          </RecordRefTag>
        )
      }}
    </PlayerContext.Consumer>
  )
}